var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBill15({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_8920",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_8920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 6H32C33.0609 6 34.0783 6.42143 34.8284 7.17157C35.5786 7.92172 36 8.93913 36 10V13.64C36.0001 15.1924 36.3616 16.7235 37.056 18.112L38.944 21.888C39.6384 23.2765 39.9999 24.8076 40 26.36V38C40 39.0609 39.5786 40.0783 38.8284 40.8284C38.0783 41.5786 37.0609 42 36 42H12C10.9391 42 9.92172 41.5786 9.17157 40.8284C8.42143 40.0783 8 39.0609 8 38V26.36C8.00011 24.8076 8.36165 23.2765 9.056 21.888L12 16V10C12 8.93913 12.4214 7.92172 13.1716 7.17157C13.9217 6.42143 14.9391 6 16 6Z",
    stroke: "#FB4945",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 30C24 31.0609 24.4214 32.0783 25.1716 32.8284C25.9217 33.5786 26.9391 34 28 34C29.0609 34 30.0783 33.5786 30.8284 32.8284C31.5786 32.0783 32 31.0609 32 30C32 28.9391 31.5786 27.9217 30.8284 27.1716C30.0783 26.4214 29.0609 26 28 26C26.9391 26 25.9217 26.4214 25.1716 27.1716C24.4214 27.9217 24 28.9391 24 30Z",
    stroke: "#FB4945",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 42C13.0609 42 14.0783 41.5786 14.8284 40.8284C15.5786 40.0783 16 39.0609 16 38V26.36C15.9999 24.8076 15.6384 23.2765 14.944 21.888L12 16",
    stroke: "#FB4945",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 14H26",
    stroke: "#FB4945",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill15);
export default __webpack_public_path__ + "static/media/bill-15.bd90a9dc4c4396c7bf81cbde2c987a42.svg";
export { ForwardRef as ReactComponent };